// extracted by mini-css-extract-plugin
module.exports = {"sectionM":"SectionM_sectionM__rlwGG"};